import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';

export class AccountDataController implements ng.IController {

  static $inject: string[] = [
    '$state',
    '$scope',
    'store',
    'ArchiSmallServices',
    '$rootScope'
  ];

  constructor(
    private $state: ng.ui.IStateService,
    private $scope: any,
    private store: ng.a0.storage.IStoreService,
    private ArchiSmallServices: ArchiSmallServices,
    private $rootScope: any
  ) {
    $scope.securityQuestions = [
      'Domanda personalizzata',
      'Qual è la tua squadra del cuore?',
      'Qual è il nome del tuo cane?',
      'Qual è il nome del tuo gatto?',
      'Qual è la tua serie TV preferita?',
      'Gruppo musicale preferito?',
      'Qual è il cognome da nubile di tua madre/nonna?',
      'Qual è il nome della tua bisnonna?',
      'Qual è il nome del/della tua maestra/o o della scuola?',
      'Qual è il nome del tuo primo animale domestico?',
      'Qual è il tuo cibo preferito?',
      'Quale film non ti stancheresti mai di vedere?',
      'Qual è il tuo libro preferito?',
      'Qual è il nome del tuo eroe da bambino?'
    ];

    $scope.tooltips = {
      'header': 'Inserisci i tuoi dati per completare la registrazione ad ArchiSMALL.',
      'indirizzoEmail': 'Inserisci l\'indirizzo e-mail (username) che utilizzerai per accedere ad ArchiSMALL.\n' +
        'ATTENZIONE: al termine della registrazione, l\'indirizzo e-mail non potrà essere cambiato.',
      'password': 'Scegli la tua password, di almeno 8 caratteri alfanumerici, che userai per accedere ad ArchiSMALL. Ti consigliamo di utilizzare lettere maiuscole, minuscole e numeri.',
      'passwordConfirmation': 'Inserisci di nuovo la password. Deve combaciare con la password già inserita.',
      'indirizzoPEC': 'Facoltativo: inserisci l\'indirizzo PEC (posta elettronica certificata) che usi per la tua azienda.',
      'securityQuestion': 'Scegli una \"Domanda di Sicurezza\". Queste domande servono a verificare la tua identità o ad aiutarti a reimpostare la password.',
      'securityAnswer': 'Scegli una \"Risposta\" alla tua \"Domanda di Sicurezza\".  Servirà a verificare la tua identità o ad aiutarti a reimpostare la password nel caso la dimenticassi.',
      'customSecurityQuestion': 'Crea la tua domanda di sicurezza personalizzata.'
    };

    if (!$scope.$parent.$parent.init()) {
      return;
    }

    // <editor-fold desc="Validations">
    $scope.validPassword = true;
    $scope.validEmail = true;
    $scope.validNumbers = /^\d+$/;
    $scope.passwordType = new RegExp('^.{8,}$');
    $scope.pecType = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$');
    $scope.fiscalCodeType = new RegExp('^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$');

    $scope.validateEmail = (email) => {
      if (email === undefined || email === null || email === '') {
        $scope.validEmail = true;
        return;
      }

      ArchiSmallServices.validateEmail(email)
        .then((response: any) => {
          $scope.validEmail = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.validatePasswords = (password, passwordConfirmation) => {

      if (password === passwordConfirmation) {
        $scope.validPassword = true;
      } else if (password !== undefined && passwordConfirmation !== undefined) {
        $scope.validPassword = false;
      }
    };
    // </editor-fold>

    $scope.user = store.get('registeringUser');
    $scope.temporaryUser = ng.copy($scope.user);
    $scope.validateEmail($scope.user.accountData.email);
    $scope.validatePasswords($scope.user.accountData.password, $scope.user.accountData.passwordConfirmation);

    switch ($scope.user.accountData.userType) {
      case 1:
        $scope.pageHeader = 'Registrazione Libero Professionista';
        $scope.pageSubHeader = 'Dati Account';
        break;
      case 2:
        $scope.pageHeader = 'Registrazione Ditta Individuale';
        $scope.pageSubHeader = 'Dati Account';
        break;
      case 3:
        $scope.pageHeader = 'Registrazione Azienda';
        $scope.pageSubHeader = 'Dati Account';
        break;
    }

    $rootScope.formsubmitted = false;
    $scope.prev = () => {
      $scope.user.accountData.lastStepSaved = '';
      store.set('registeringUser', $scope.user);
      $state.go('registration.registration-type');
    };
    $scope.next = () => {

      if ($scope.user.accountData.userType === 1) {
        $scope.user.accountData.lastStepSaved = 'organization-data-lp';
        store.set('registeringUser', $scope.user);
        $state.go('registration.organization-data-lp');
      } else {
        $scope.user.accountData.lastStepSaved = 'organization-data';
        store.set('registeringUser', $scope.user);
        $state.go('registration.organization-data');
      }
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/account-data/account-data.controller.ts